import React from "react";
/** Components Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleArrowRight as RightArrows,
  faClipboardCheck as OrderComplete,
  faHourglassHalf as StandBy,
  faBoxOpen as Producted,
  faBox as Packing,
  faTruckArrowRight as Delivery,
} from "@fortawesome/free-solid-svg-icons";

function ArrowIconObj({ style }) {
  return (
    <FontAwesomeIcon
      className="order_status_arrow"
      icon={RightArrows}
      style={style}
      fontSize={30}
    />
  );
}

function OrderStatusCard({ orderList = [] }) {
  return (
    <>
      {orderList.map((item, index) => {
        return (
          <div key={index} className="order_status_wrap">
            <div className="order_status_text">
              <span style={{ whiteSpace: "pre-wrap" }}>{item.name}</span>
            </div>
            <div className="order_status_contents">
              <div
                className={
                  "order_status_content " +
                  (item.status === "0" ? "order_status_selected" : "")
                }
              >
                <FontAwesomeIcon
                  className="order_status_icon_component"
                  icon={OrderComplete}
                  fontSize={30}
                />
                <span>주문 완료</span>
              </div>
              <ArrowIconObj
                style={
                  item.status === "0"
                    ? {
                        borderRadius: "30px",
                        backgroundColor: "#D70929",
                      }
                    : null
                }
              />
              <div
                className={
                  "order_status_content " +
                  (item.status === "1" ? "order_status_selected" : "")
                }
              >
                <FontAwesomeIcon
                  className="order_status_icon_component"
                  icon={Producted}
                  fontSize={30}
                />
                <span>생산 중</span>
              </div>
              <ArrowIconObj
                style={
                  item.status === "1"
                    ? {
                        borderRadius: "30px",
                        backgroundColor: "#D70929",
                      }
                    : null
                }
              />
              <div
                className={
                  "order_status_content " +
                  (item.status === "2" || item.status === "3"
                    ? "order_status_selected"
                    : "")
                }
              >
                <FontAwesomeIcon
                  className="order_status_icon_component"
                  icon={Packing}
                  fontSize={30}
                />
                <span>포장 완료</span>
              </div>
              <ArrowIconObj
                style={
                  item.status === "2" || item.status === "3"
                    ? {
                        borderRadius: "30px",
                        backgroundColor: "#D70929",
                      }
                    : null
                }
              />
              <div
                className={
                  "order_status_content " +
                  (item.status === "4" ? "order_status_selected" : "")
                }
              >
                <FontAwesomeIcon
                  className="order_status_icon_component"
                  icon={Delivery}
                  fontSize={30}
                />
                <span>출하 완료</span>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}

OrderStatusCard.defaultProps = {};

export default OrderStatusCard;
